import { css, sva } from "@stubhub/broadway-foundation/css";

export const fanProtectMobilePlacement = css({
  display: "flex",
  marginBlockStart: "-primitives.150",
  paddingBlockStart: "primitives.0",
  paddingBlockEnd: "primitives.250",
  paddingInline: "primitives.150",
  flexDirection: "column",
  alignItems: "stretch",
  width: "full",
});

export const iconTile = css({
  flexGrow: "0",
  flexShrink: "0",
  flexBasis: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingBlock: "primitives.100",
  paddingInline: "primitives.100",
  borderStartRadius: "full",
  borderEndRadius: "full",
  backgroundColor: "bg.fill.info",
  color: "bg.surface",
});

export const detailModalContent = css({
  maxWidth: "[520px]",
  maxHeight: "[800px]",
});

export const bannerButton = css({
  cursor: "pointer",
});

export const benefitsGrid = css({
  display: "grid",
  gridTemplateColumns: "[1fr 1fr]",
  rowGap: "primitives.150",
  columnGap: "primitives.150",
});

export const bannerCardRecipe = sva({
  slots: ["card", "content", "textBlock", "chipsRow", "chevronIcon"],
  className: "bannerCard",
  base: {
    card: {
      display: "flex",
      paddingBlock: "primitives.200",
      paddingInline: "primitives.200",
      flexDirection: "column",
      alignItems: "center",
      rowGap: "primitives.150",
      alignSelf: "stretch",
      borderStartRadius: "container",
      borderEndRadius: "container",
      boxShadow: "floating",
      backgroundColor: "bg",
      tablet: {
        width: "[400px]",
        alignSelf: "auto",
      },
    },
    content: {
      display: "flex",
      minHeight: "[42px]",
      alignItems: "center",
      columnGap: "primitives.150",
      alignSelf: "stretch",
    },
    textBlock: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      flexGrow: "1",
      flexShrink: "0",
      flexBasis: "primitives.0",
    },
    chipsRow: {
      display: "none",
      tablet: {
        display: "flex",
        alignItems: "center",
        columnGap: "primitives.100",
        alignSelf: "stretch",
      },
    },
    chevronIcon: {
      flexGrow: "0",
      flexShrink: "0",
      flexBasis: "auto",
      color: "text.subtle",
    },
  },
});

export const benefitCardRecipe = sva({
  slots: ["card", "icon", "textBlock"],
  className: "benefitCard",
  base: {
    card: {
      display: "flex",
      paddingBlock: "primitives.200",
      paddingInline: "primitives.200",
      flexDirection: "column",
      alignItems: "flex-start",
      rowGap: "primitives.150",
      flexGrow: "1",
      flexShrink: "0",
      flexBasis: "primitives.0",
      borderStartRadius: "container",
      borderEndRadius: "container",
      borderBlockWidth: "thin",
      borderInlineWidth: "thin",
      borderBlockStyle: "solid",
      borderInlineStyle: "solid",
      borderBlockColor: "border",
      borderInlineColor: "border",
      backgroundColor: "bg",
    },
    icon: {
      display: "flex",
      paddingBlock: "primitives.100",
      paddingInline: "primitives.100",
      justifyContent: "center",
      alignItems: "center",
      borderStartRadius: "element.small",
      borderEndRadius: "element.small",
      backgroundColor: "bg.surface.info",
      color: "text.info",
    },
    textBlock: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      rowGap: "primitives.25",
      alignSelf: "stretch",
    },
  },
});

export const detailBodyRecipe = sva({
  slots: ["container", "title", "textBlock"],
  className: "detailBody",
  base: {
    container: {
      display: "flex",
      flexDirection: "column",
      rowGap: "primitives.300",
      paddingBlockEnd: "primitives.300",
    },
    title: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      rowGap: "primitives.200",
      alignSelf: "stretch",
    },
    textBlock: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      rowGap: "primitives.50",
      alignSelf: "stretch",
    },
  },
});
